module.exports = __webpack_public_path__ + "static/media/Cake.da953f82.svg";